import { render, staticRenderFns } from "./FormData.vue?vue&type=template&id=7f9cc3bb&scoped=true"
import script from "./FormData.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormData.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FormData.vue?vue&type=style&index=0&id=7f9cc3bb&prod&scoped=true&lang=scss"
import style1 from "./FormData.vue?vue&type=style&index=1&id=7f9cc3bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9cc3bb",
  null
  
)

export default component.exports